<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="head-user-modal-list">
            <h2>Deseja visualizar os dados sensíveis?</h2>
         </div>
         
         <!-- <div class="body-user-modal-list">
             Os dados sensíveis contem informações que não podem ser visualizadas por qualquer um nem compartilhada.
         </div> -->
         <div class="footer-user-modal-list">
            <button mat-button class="btn-primary block" (click)="clickConfirm()">
                <span *ngIf="isLoading == false">Sim, visualizar</span>
                <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading == true"></mat-spinner>
            </button>
            <button mat-button class="btn-secundary block"(click)="clickCancel()">Cancelar</button>
        </div>
    </div>
</div>
